import { PageContainer, PageHeader, Spread, Text, VStack } from '@/components/Atoms'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { PageError } from '@/components/PageError'
import { PageLoader } from '@/components/PageLoader'
import { useBannerDetails } from '@/hooks/queries/useBanners'
import { createFileRoute } from '@tanstack/react-router'
import { BannerActiveAssortmentCard } from './-components/BannerActiveAssortmentCard'
import { BannerAssortmentCard } from './-components/BannerAssortmentCard'
import { BannerDetailsCard } from './-components/BannerDetailsCard'
import { BannerStoresCard } from './-components/BannerStoresCard'

export const Route = createFileRoute('/_auth/_modules/_app/customers/banners/$bannerId')({
  component: BannerDetails,
  loader: ({ params: { bannerId } }) => ({
    crumb: bannerId,
  }),
})

function BannerDetails() {
  const { bannerId } = Route.useParams()

  const { isPending, error, data: banner } = useBannerDetails(bannerId)

  if (error) return <PageError message={error.message} />

  if (!banner || isPending) return <PageLoader />

  return (
    <PageContainer>
      <Spread align="start">
        <VStack gap="sm">
          <PageHeader>{banner.name}</PageHeader>
          <Text tone="muted" weight="medium">
            ERP {banner.sapErp}
          </Text>
        </VStack>
      </Spread>

      <BannerDetailsCard bannerId={bannerId} />

      <PermissionsGuard required={['active_assortment_view']}>
        <BannerActiveAssortmentCard bannerId={bannerId} />
      </PermissionsGuard>

      <PermissionsGuard required={['assortment_banners_view']}>
        <BannerAssortmentCard bannerId={bannerId} />
      </PermissionsGuard>

      <PermissionsGuard required={['customers_stores_view']}>
        <BannerStoresCard bannerId={bannerId} />
      </PermissionsGuard>
    </PageContainer>
  )
}
